import { styled } from "@mui/material";
import { ReactComponent as Medium } from "assets/icons/medium.svg";
import { ReactComponent as Arrow } from "assets/icons/arrow_up.svg";

const ArrowContainerStyled = styled("div")({
  display: "flex",
  alignItems: "center",
  "&.up": {
    transform: "rotate(180deg)",
  },
});

const PriorityIcon = ({
  priority,
  size = "16px",
  stroke = "#fff",
  strokeWidth = "0.3",
}) => {
  const priorityNumber = Number(priority);

  if (isNaN(priorityNumber) || priorityNumber < 0 || priorityNumber > 1) {
    return <></>;
  }

  if (priorityNumber === 1) {
    return (
      <ArrowContainerStyled>
        <Arrow
          stroke={stroke}
          fill="red"
          strokeWidth={strokeWidth}
          width={size}
          height={size}
        />
      </ArrowContainerStyled>
    );
  }

  if (priorityNumber > 0.5) {
    return (
      <ArrowContainerStyled>
        <Arrow
          stroke={stroke}
          fill="orange"
          strokeWidth={strokeWidth}
          width={size}
          height={size}
        />
      </ArrowContainerStyled>
    );
  }

  if (priorityNumber > 0.25) {
    return (
      <ArrowContainerStyled>
        <Medium
          stroke={stroke}
          fill="#d1c80a"
          strokeWidth={strokeWidth}
          width={size}
          height={size}
        />
      </ArrowContainerStyled>
    );
  }

  if (priorityNumber > 0) {
    return (
      <ArrowContainerStyled className="up">
        <Arrow
          stroke={stroke}
          fill="cyan"
          strokeWidth={strokeWidth}
          width={size}
          height={size}
        />
      </ArrowContainerStyled>
    );
  }

  return (
    <ArrowContainerStyled className="up">
      <Arrow
        stroke={stroke}
        fill="blue"
        strokeWidth={strokeWidth}
        width={size}
        height={size}
      />
    </ArrowContainerStyled>
  );
};

export default PriorityIcon;
